import SvgIcon from "@mui/material/SvgIcon";

export default function CalendarIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 32 32">
      <path d="M2.13 27.2V11.47h22.4V27.2Zm2.4-19.73v1.86h1.6V7.47h14.4v1.86h1.6V7.47h2.4v2.4H2.13v-2.4zm17.6-1.6V4h-1.6v1.87H6.13V4h-1.6v1.87h-4V28.8h25.6V5.87h-4" />
      <path d="M11.93 19.14c.73-.26 1.16-1 1.16-1.72 0-1.38-1.1-2.27-2.56-2.27-1.47 0-2.66.83-2.69 2.34H9.3c.02-.73.52-1.08 1.24-1.08.63 0 1.1.47 1.1 1.04 0 .75-.46 1.08-1.24 1.08h-.6v1.25h.6c.75 0 1.4.38 1.4 1.21 0 .77-.55 1.2-1.26 1.2-.7 0-1.24-.41-1.3-1.2H7.8c.04 1.5 1.24 2.47 2.72 2.47 1.5 0 2.73-.84 2.73-2.44 0-.83-.49-1.65-1.32-1.88m2.4-2.43v1.58L16.1 17v6.31h1.44V15.3H16.3l-1.97 1.41" />
    </SvgIcon>
  );
}
